
// scroll to the bottom of the page
export function scroll_to_bottom() {
  window.scrollTo(0,document.body.scrollHeight);
}